import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { PermissionKey, Role, ROLE_PERMISSIONS } from "../rbac";

export const usePermissions = () => {
  const role: Role = useSelector((state: any) => state.user.role);

  const permissions = useMemo(() => ROLE_PERMISSIONS[role] ?? [], [role]);

  const hasPermission = useCallback(
    (permission?: PermissionKey) => {
      if (!permission) return true;

      return permissions.includes(permission);
    },
    [permissions]
  );

  return {
    role,
    permissions,
    hasPermission,
  };
};
